// External
import React from 'react';
import { array, bool, func } from 'prop-types';
import { BrightnessNone, CheckCircle, Loading } from '@nike/nike-design-system-icons';
import { ButtonStyled } from '@nike/nike-design-system-components';

// Internal

// Constants
const classname = 'filesDisplay';
const getUploadedIndex = (list, id) =>
  list.findIndex(({ name, lastModified, size }) => `${name}-${lastModified}-${size}` === id);

const FilesDisplay = ({ files, uploadedFiles, isSubmitting, deleteFile }) => (
  <ul className={classname}>
    {files.map(({ name, lastModified, size }, index) => {
      const derivedId = `${name}-${lastModified}-${size}`;
      const uploadedIndex = getUploadedIndex(uploadedFiles, derivedId);
      const isUploaded = uploadedIndex > -1;
      const { success = false } = (isUploaded && uploadedFiles[uploadedIndex]) || {};

      return (
        <li key={derivedId} className={`${classname}__line`}>
          <div className={`${classname}__line__name`}>{name}</div>
          <div className={`${classname}__line__status`}>
            {isUploaded && success && <CheckCircle alt='check mark' className='check' />}
            {isUploaded && !success && <BrightnessNone alt='error occurred' className='error' />}
            {!isUploaded && isSubmitting && (
              <Loading alt='loading' className='loading' data-testid='uploadCatalog-loading-icon' />
            )}
            {!isUploaded && !isSubmitting && (
              <ButtonStyled
                data-testid='uploadCatalog-delete-file'
                disabled={isSubmitting || uploadedFiles.length > 0}
                appearance='secondary'
                onClick={() => deleteFile(index)}
                className='delete'
                size='responsive'
              >
                Delete
              </ButtonStyled>
            )}
          </div>
        </li>
      );
    })}
  </ul>
);

FilesDisplay.propTypes = {
  files: array.isRequired,
  uploadedFiles: array,
  isSubmitting: bool.isRequired,
  deleteFile: func.isRequired
};

FilesDisplay.defaultProps = {
  uploadedFiles: []
};

export default FilesDisplay;
